import React from "react";
import { Button, Table } from "react-bootstrap";

/**
 * Card content for sending initial "thanks for signing up" emails.
 */
export default function SendInitialEmailCard({
  selectedDays,
  selectedLocation,
  filteredAPIDateStudentResults,
  dataDirty,
  loading,

  // render helpers from parent
  locationSelector,
  noDateSelectedPrompt,
  statusAlerts,

  // callbacks
  onSendInitalEmailBulk,
  onRefreshStatus,
  onSetActiveKey,
}) {
  if (selectedDays.length === 0) {
    return noDateSelectedPrompt;
  }

  if (selectedLocation.length === 0) {
    return (
      <div>
        <p>
          You have not selected a road test location. Please select a
          location first!
        </p>
        <div className="padLeft">
          {selectedLocation.length > 0 ? (
            <div>Now viewing lessons for: {selectedLocation}</div>
          ) : null}
          {locationSelector}
        </div>
      </div>
    );
  }

  if (filteredAPIDateStudentResults.length === 0) {
    return (
      <div>
        <div>
          No students found. Please select a new day, or add some
          students.
        </div>
        <br></br>
        <Button
          variant="primary"
          onClick={() => onSetActiveKey("selectDays")}
        >
          Select New Day Range
        </Button>
        <Button
          variant="primary"
          onClick={() => onSetActiveKey("manageStudents")}
        >
          Add Some Students
        </Button>
        <br></br>
      </div>
    );
  }

  return (
    <div>
      <div>{statusAlerts}</div>
      <Button
        disabled={dataDirty || loading === true}
        onClick={() => onSendInitalEmailBulk([])}
      >
        {" "}
        Send all Unsent Inital Emails{" "}
      </Button>

      <Button
        className="rightBut"
        disabled={dataDirty}
        onClick={onRefreshStatus}
      >
        {" "}
        Refresh Status{" "}
      </Button>
      <br></br>
      <br></br>
      {!dataDirty ? (
        <Table striped bordered hover size="sm">
          <thead>
            <tr>
              <th>Name</th>
              <th>Inital Email</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredAPIDateStudentResults.map((x, index) => {
              return (
                <tr key={x.timestamp}>
                  <td>{x.fName + " " + x.lName}</td>
                  <td>{x.emailInitalState}</td>
                  <td>
                    <Button
                      disabled={dataDirty || loading}
                      onClick={() => onSendInitalEmailBulk([x])}
                      size="sm"
                    >
                      Send Inital Email
                    </Button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      ) : null}
    </div>
  );
}
